module.exports = __webpack_public_path__ + "img/6.e94e5ee2.png";